export default __webpack_public_path__ + "static/media/tiktok.c9cb4c93.svg";